/**
* @ngdoc component
* @name common.address.component:itxAddressName
* @description
* User name
* @param {object} model Address model
* @param {object} form form
* @param {string} class Classes
*/
(function() {
    'use strict';

    var itxAddressName = {
        bindings: {
            model:'=',
            form:'=',
            class:'<',
            completeInfo: '=',
            isChina: '<',
            checkRequired:'<'
        },
        controller:   itxAddressNameCtrl,
        templateUrl: 'address-name.component.html'
    };

    itxAddressNameCtrl.$inject = [
        'MdFeelMyAccountService',
        'ItxTranslateSvc',
        'crmService',
        'CmsConfigSvc'
    ];

    function itxAddressNameCtrl (
        MdFeelMyAccountService,
        ItxTranslateSvc,
        crmService,
        CmsConfigSvc
    ) {
        var _this = this;
        _this.systemPointsEnabled = false;
        _this.is200enabled = false;
        
        _this.$onInit = function(){
            _this.is360 = crmService.is360();
            _this.checkRequired = true;

            // Para Naver, en el caso que naver nos fuerce un guion para el nombre, vaciamos el campo
            // Para no poder avanzar y que el formulario nos obligue a introducir el nombre y/o apellido
            if(_this.model.firstName === '-') {
                _this.model.firstName = '';
            }
            if(_this.model.lastName === '-') {
                _this.model.lastName = '';
            }
            MdFeelMyAccountService.check200PointsEnabled().then(function (isEnabled) {
                _this.is200enabled = true;
            });

            // Comprobacion del estado del sistema de puntos
            CmsConfigSvc.getProperty('feel_points_program_enabled').then(function (systemPointsEnabled) {
                if (systemPointsEnabled) {
                    _this.systemPointsEnabled = true;
                }
            });

        };

        _this.$onChanges = function (changeObj) {
            if(typeof changeObj.checkRequired != undefined){
                _this.checkRequired = changeObj.checkRequired.currentValue;
            } 
        };

    }

    angular.module('itxApp.common')
    .component('itxAddressName',itxAddressName);

})();